<template>
    <div
        class="modal fade"
        id="bookModal"
        tabindex="-1"
        aria-labelledby="bookModalLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
        >
            <form class="modal-content" @submit.prevent="makeBooking">
                <div class="modal-header bg-c-secondary text-white">
                    <h5 class="modal-title" id="bookModalLabel">
                        {{ price[`title_${$store.state.locale}`] }}
                    </h5>
                    <button
                        type="button"
                        class="btn p-1 d-flex align-items-center justify-content-center"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    >
                        <i class="fas fa-times fa-lg text-white"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group mt-2 mb-4">
                        <label for="company_name" class="form-label"
                            >{{ localise("booking", "company_name")
                            }}<span class="text-danger ms-1">*</span></label
                        >
                        <input
                            id="company_name"
                            name="company_name"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.company_name.$error ? 'is-invalid' : ''"
                            :placeholder="
                                localise('booking', 'company_name_placeholder')
                            "
                            v-model="company_name"
                        />

                        <div
                            v-if="v$.company_name.minLength"
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-2 mb-4">
                        <label for="company_id" class="form-label"
                            >{{ localise("booking", "company_id")
                            }}<span class="text-danger ms-1">*</span></label
                        >
                        <input
                            id="company_id"
                            name="company_id"
                            type="number"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.company_id.$error ? 'is-invalid' : ''"
                            :placeholder="
                                localise('booking', 'company_id_placeholder')
                            "
                            v-model="company_id"
                        />

                        <div
                            v-if="
                                v$.company_id.minLength ||
                                v$.company_id.maxLength
                            "
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "id") }}
                        </div>
                    </div>
                    <div class="form-group mt-2 mb-4">
                        <label for="company_director" class="form-label"
                            >{{ localise("booking", "company_director")
                            }}<span class="text-danger ms-1">*</span></label
                        >
                        <input
                            id="company_director"
                            name="company_director"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="
                                v$.company_director.$error ? 'is-invalid' : ''
                            "
                            :placeholder="
                                localise(
                                    'booking',
                                    'company_director_placeholder'
                                )
                            "
                            v-model="company_director"
                        />

                        <div
                            v-if="v$.company_director.minLength"
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-2 mb-4">
                        <label for="contact_person" class="form-label"
                            >{{ localise("booking", "contact_person")
                            }}<span class="text-danger ms-1">*</span></label
                        >
                        <input
                            id="contact_person"
                            name="contact_person"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :placeholder="
                                localise(
                                    'booking',
                                    'contact_person_placeholder'
                                )
                            "
                            :class="
                                v$.contact_person.$error ? 'is-invalid' : ''
                            "
                            v-model="contact_person"
                        />

                        <div
                            v-if="v$.contact_person.minLength"
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-2 mb-4">
                        <label for="phone" class="form-label"
                            >{{ localise("tour_form", "phone")
                            }}<span class="text-danger ms-1">*</span></label
                        >
                        <input
                            id="phone"
                            name="phone"
                            type="number"
                            class="form-control py-3 rounded-c-3"
                            :placeholder="
                                localise('tour_form', 'phone_placeholder')
                            "
                            :class="v$.phone.$error ? 'is-invalid' : ''"
                            v-model="phone"
                        />

                        <div v-if="v$.phone.minLength" class="invalid-feedback">
                            {{ localise("validation", "phone") }}
                        </div>
                    </div>
                    <div class="form-group mt-2 mb-4">
                        <label for="email" class="form-label"
                            >{{ localise("tour_form", "email")
                            }}<span class="text-danger ms-1">*</span></label
                        >
                        <input
                            id="email"
                            name="email"
                            type="email"
                            class="form-control py-3 rounded-c-3"
                            :placeholder="
                                localise('tour_form', 'email_placeholder')
                            "
                            :class="v$.email.$error ? 'is-invalid' : ''"
                            v-model="email"
                        />

                        <div v-if="v$.email.email" class="invalid-feedback">
                            {{ localise("validation", "email") }}
                        </div>
                    </div>
                </div>
                <div
                    class="modal-footer d-flex flex-column align-items-center justify-content-center"
                >
                    <button
                        type="submit"
                        class="btn btn-sm btn-c-secondary shadow rounded-c-3 px-5 py-3 text-white"
                        :disabled="$store.state.loading"
                    >
                        <div
                            v-if="$store.state.loading"
                            class="spinner-grow spinner-grow-sm text-white"
                            role="status"
                        >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <span v-else>
                            <i class="fas fa-paper-plane me-1"></i>
                            {{ localise("global", "send") }}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import translations from "../../helpers/translations";
import useVuelidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";
import { commercialBooking } from "../../services/InternalApiService";

export default {
    name: "CommercialBookingModal",
    props: ["price"],
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            company_name: "",
            company_id: "",
            company_director: "",
            contact_person: "",
            phone: "",
            email: "",
        };
    },
    validations() {
        return {
            company_name: { required, minLength: minLength(5) },
            company_id: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
            },
            company_director: { required, minLength: minLength(5) },
            contact_person: { required, minLength: minLength(5) },
            phone: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(9),
            },
            email: { required, email },
        };
    },
    methods: {
        makeBooking() {
            this.v$.$validate();
            this.v$.$touch();
            if (!this.v$.$invalid) {
                this.$store.state.loading = true;
                setTimeout(() => {
                    commercialBooking({
                        company_name: this.company_name,
                        company_id: this.company_id,
                        company_director: this.company_director,
                        contact_person: this.contact_person,
                        phone: this.phone,
                        email: this.email,
                        price_id: this.price.id,
                    })
                        .then((res) => {
                            this.$store.state.loading = false;
                            if (res.data.status === "success") {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: this.localise(
                                        "booking",
                                        "success_message"
                                    ),
                                    showConfirmButton: false,
                                    timer: 1500,
                                });
                                this.closeModal();
                                setTimeout(() => {
                                    this.$emit("refresh-pricelist");
                                }, 1500);
                            }
                        })
                        .catch(console.error());
                }, 0);
            } else {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: this.localise("validation", "error"),
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        },
        clearValidation() {
            if (!document.querySelector(".modal.show")) {
                this.v$.$reset();
            }
        },
        closeModal() {
            let bookingModal = document.querySelector(".modal.show");
            let modal = bootstrap.Modal.getInstance(bookingModal);
            modal.hide();
            this.clearInputs();
        },
        clearInputs() {
            this.company_name = "";
            this.company_id = "";
            this.company_director = "";
            this.contact_person = "";
            this.phone = "";
            this.email = "";
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
    },
    updated() {
        this.clearValidation();
    },
};
</script>
